module.exports = __webpack_public_path__ + "static/media/Logo.dd45882f.png";